import React from "react";
import { string } from "prop-types";

const ClearIcon = props => (
  <svg height={props.width} viewBox="0 0 15 15" width={props.width}>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-817.000000, -392.000000)">
        <g transform="translate(817.000000, 392.000000)">
          <circle cx="7.5" cy="7.5" fill="#CDCDCD" r="7.5" />
          <g
            stroke="#FFFFFF"
            strokeLinecap="square"
            transform="translate(7.500000, 7.853553) rotate(-315.000000) translate(-7.500000, -7.853553) translate(3.500000, 3.853553)"
          >
            <path d="M3.75,0.305407578 L3.75,7.19350278" />
            <path d="M7.19459096,3.75 L0.305078529,3.75" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

ClearIcon.propTypes = {
  /** Give the icon width/height (default is 8px) */
  width: string
};

ClearIcon.defaultProps = {
  width: "8px"
};

export default ClearIcon;
